import { render } from "./dialog-cancel.vue?vue&type=template&id=5de6beca"
import script from "./dialog-cancel.vue?vue&type=script&lang=js"
export * from "./dialog-cancel.vue?vue&type=script&lang=js"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__